// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"3a54c6a7","435":"f12163b0","612":"5fa1a74a"}[chunkId] + ".chunk.css";
};